import { useEffect, useState } from 'react'
import { useRemoteClientGet } from '../../../../../configs/http-client'
import { CatchMessageError } from '../../../../../remote/catch-message-error'
import { useLocalStorage } from '../../../../../remote/local-storage'
import { CashRegisterInputOutput } from '../../../../../remote/types/cash-register-input-output'

export const LoadCashRegisterId = (id: any) => {
  const { getUnitId } = useLocalStorage()
  const [data, setData] = useState<CashRegisterInputOutput[] | null>(null)

  const { remoteClientGet } = useRemoteClientGet('finance')

  useEffect(() => {
    if (id) {
      remoteClientGet(`/caixa/${id}/historico?idUnidade=${getUnitId()}`)
        .then((response) => {
          setData(response.data.data)
        })
        .catch(CatchMessageError)
    }
  }, [id])

  const reloadCashRegisterById = () => {
    remoteClientGet(`/caixa/${id}/historico?idUnidade=${getUnitId()}`)
      .then((response) => {
        setData(response.data.data)
      })
      .catch(CatchMessageError)
  }

  return {
    reloadCashRegisterById,
    data
  }
}
